import { render } from "./TermsOfUse.vue?vue&type=template&id=793fd7ba"
import script from "./TermsOfUse.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TermsOfUse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "793fd7ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('793fd7ba', __exports__)) {
    api.reload('793fd7ba', __exports__)
  }
  
  module.hot.accept("./TermsOfUse.vue?vue&type=template&id=793fd7ba", () => {
    api.rerender('793fd7ba', render)
  })

}


export default __exports__